// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from "./client";
import { client } from "./client.gen";

import type {
  ApplyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPostData,
  ApplyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPostErrors,
  ApplyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPostResponses,
  BoomBoomGetData,
  BoomBoomGetResponses,
  CreateFinancialHelpFinancialHelpsPostData,
  CreateFinancialHelpFinancialHelpsPostErrors,
  CreateFinancialHelpFinancialHelpsPostResponses,
  CreatePostingHohishesHohishUuidPostingsPostData,
  CreatePostingHohishesHohishUuidPostingsPostErrors,
  CreatePostingHohishesHohishUuidPostingsPostResponses,
  CreateZoneGeographiesZonesPostData,
  CreateZoneGeographiesZonesPostErrors,
  CreateZoneGeographiesZonesPostResponses,
  DeleteAgencyGeographiesAgenciesAgencyUuidDeleteData,
  DeleteAgencyGeographiesAgenciesAgencyUuidDeleteErrors,
  DeleteAgencyGeographiesAgenciesAgencyUuidDeleteResponses,
  DeletePostalCodesBindingGeographiesPostalCodesBindingDeleteData,
  DeletePostalCodesBindingGeographiesPostalCodesBindingDeleteErrors,
  DeletePostalCodesBindingGeographiesPostalCodesBindingDeleteResponses,
  DeletePostingHohishesHohishUuidPostingsPostingUuidDeleteData,
  DeletePostingHohishesHohishUuidPostingsPostingUuidDeleteErrors,
  DeletePostingHohishesHohishUuidPostingsPostingUuidDeleteResponses,
  DeleteUrbanAreaGeographiesUrbanAreasUrbanAreaSlugDeleteData,
  DeleteUrbanAreaGeographiesUrbanAreasUrbanAreaSlugDeleteErrors,
  DeleteUrbanAreaGeographiesUrbanAreasUrbanAreaSlugDeleteResponses,
  GetAgenciesGeographiesAgenciesGetData,
  GetAgenciesGeographiesAgenciesGetErrors,
  GetAgenciesGeographiesAgenciesGetResponses,
  GetAgenciesPostalCodesBindingsGeographiesAgenciesPostalCodesBindingsGetData,
  GetAgenciesPostalCodesBindingsGeographiesAgenciesPostalCodesBindingsGetResponses,
  GetAstreinteMailsAircallMfaAstreinteMailsGetData,
  GetAstreinteMailsAircallMfaAstreinteMailsGetResponses,
  GetDepartmentsGeographiesDepartmentsGetData,
  GetDepartmentsGeographiesDepartmentsGetResponses,
  GetExternalProvidersErrorsExternalProvidersErrorsGetData,
  GetExternalProvidersErrorsExternalProvidersErrorsGetErrors,
  GetExternalProvidersErrorsExternalProvidersErrorsGetResponses,
  GetFinancialHelpsFinancialHelpsGetData,
  GetFinancialHelpsFinancialHelpsGetResponses,
  GetHohishesHohishesGetData,
  GetHohishesHohishesGetErrors,
  GetHohishesHohishesGetResponses,
  GetHohishHohishesHohishUuidGetData,
  GetHohishHohishesHohishUuidGetErrors,
  GetHohishHohishesHohishUuidGetResponses,
  GetJobsHohishesJobsGetData,
  GetJobsHohishesJobsGetResponses,
  GetLegalEntityLegalEntitiesGetData,
  GetLegalEntityLegalEntitiesGetResponses,
  GetMeHohishesMeGetData,
  GetMeHohishesMeGetResponses,
  GetPostalCodesGeographiesPostalCodesGetData,
  GetPostalCodesGeographiesPostalCodesGetResponses,
  GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetData,
  GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetErrors,
  GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetResponses,
  GetPostingsHohishesHohishUuidPostingsGetData,
  GetPostingsHohishesHohishUuidPostingsGetErrors,
  GetPostingsHohishesHohishUuidPostingsGetResponses,
  GetRegionsGeographiesRegionsGetData,
  GetRegionsGeographiesRegionsGetErrors,
  GetRegionsGeographiesRegionsGetResponses,
  GetSecurityPolicyPermerSecurityPolicyGetData,
  GetSecurityPolicyPermerSecurityPolicyGetResponses,
  GetUrbanAreasGeographiesUrbanAreasGetData,
  GetUrbanAreasGeographiesUrbanAreasGetErrors,
  GetUrbanAreasGeographiesUrbanAreasGetResponses,
  GetZonesGeographiesZonesGetData,
  GetZonesGeographiesZonesGetErrors,
  GetZonesGeographiesZonesGetResponses,
  PatchHohishHohishesHohishUuidPatchData,
  PatchHohishHohishesHohishUuidPatchErrors,
  PatchHohishHohishesHohishUuidPatchResponses,
  PostAgencyGeographiesAgenciesPostData,
  PostAgencyGeographiesAgenciesPostErrors,
  PostAgencyGeographiesAgenciesPostResponses,
  PostUrbanAreaGeographiesUrbanAreasPostData,
  PostUrbanAreaGeographiesUrbanAreasPostErrors,
  PostUrbanAreaGeographiesUrbanAreasPostResponses,
  PreviewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPostData,
  PreviewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPostErrors,
  PreviewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPostResponses,
  PutAgencyGeographiesAgenciesAgencyUuidPutData,
  PutAgencyGeographiesAgenciesAgencyUuidPutErrors,
  PutAgencyGeographiesAgenciesAgencyUuidPutResponses,
  PutUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPutData,
  PutUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPutErrors,
  PutUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPutResponses,
  StatusDbStatusDbGetData,
  StatusDbStatusDbGetResponses,
  StatusStatusGetData,
  StatusStatusGetResponses,
  UpdateFinancialHelpFinancialHelpsHelpUuidPutData,
  UpdateFinancialHelpFinancialHelpsHelpUuidPutErrors,
  UpdateFinancialHelpFinancialHelpsHelpUuidPutResponses,
  UpdatePostingHohishesHohishUuidPostingsPostingUuidPostData,
  UpdatePostingHohishesHohishUuidPostingsPostingUuidPostErrors,
  UpdatePostingHohishesHohishUuidPostingsPostingUuidPostResponses,
  UpdateZoneGeographiesZonesZoneUuidPutData,
  UpdateZoneGeographiesZonesZoneUuidPutErrors,
  UpdateZoneGeographiesZonesZoneUuidPutResponses,
  UpsertPostalCodesBindingGeographiesPostalCodesBindingPutData,
  UpsertPostalCodesBindingGeographiesPostalCodesBindingPutErrors,
  UpsertPostalCodesBindingGeographiesPostalCodesBindingPutResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Get Astreinte Mails
 *
 * Return all emails sent to bonjour+astreinteN@ouihelp.fr in the last 6 hours.
 */
export const getAstreinteMailsAircallMfaAstreinteMailsGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetAstreinteMailsAircallMfaAstreinteMailsGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetAstreinteMailsAircallMfaAstreinteMailsGetResponses,
    unknown,
    ThrowOnError
  >({
    url: "/2/aircall-mfa/astreinte-mails",
    ...options,
  });
};

/**
 * Get External Providers Errors
 */
export const getExternalProvidersErrorsExternalProvidersErrorsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetExternalProvidersErrorsExternalProvidersErrorsGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetExternalProvidersErrorsExternalProvidersErrorsGetResponses,
    GetExternalProvidersErrorsExternalProvidersErrorsGetErrors,
    ThrowOnError
  >({
    url: "/2/external-providers/errors",
    ...options,
  });
};

/**
 * Get Financial Helps
 */
export const getFinancialHelpsFinancialHelpsGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetFinancialHelpsFinancialHelpsGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetFinancialHelpsFinancialHelpsGetResponses,
    unknown,
    ThrowOnError
  >({
    url: "/2/financial-helps",
    ...options,
  });
};

/**
 * Create Financial Help
 */
export const createFinancialHelpFinancialHelpsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateFinancialHelpFinancialHelpsPostData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    CreateFinancialHelpFinancialHelpsPostResponses,
    CreateFinancialHelpFinancialHelpsPostErrors,
    ThrowOnError
  >({
    url: "/2/financial-helps",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Update Financial Help
 */
export const updateFinancialHelpFinancialHelpsHelpUuidPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFinancialHelpFinancialHelpsHelpUuidPutData, ThrowOnError>
) => {
  return (options.client ?? client).put<
    UpdateFinancialHelpFinancialHelpsHelpUuidPutResponses,
    UpdateFinancialHelpFinancialHelpsHelpUuidPutErrors,
    ThrowOnError
  >({
    url: "/2/financial-helps/{help_uuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Agencies Postal Codes Bindings
 */
export const getAgenciesPostalCodesBindingsGeographiesAgenciesPostalCodesBindingsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetAgenciesPostalCodesBindingsGeographiesAgenciesPostalCodesBindingsGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GetAgenciesPostalCodesBindingsGeographiesAgenciesPostalCodesBindingsGetResponses,
    unknown,
    ThrowOnError
  >({
    url: "/2/geographies/agencies-postal-codes-bindings",
    ...options,
  });
};

/**
 * Get Postal Codes
 */
export const getPostalCodesGeographiesPostalCodesGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetPostalCodesGeographiesPostalCodesGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetPostalCodesGeographiesPostalCodesGetResponses,
    unknown,
    ThrowOnError
  >({
    url: "/2/geographies/postal-codes",
    ...options,
  });
};

/**
 * Get Postal Codes With Bindings
 */
export const getPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetResponses,
    GetPostalCodesWithBindingsGeographiesPostalCodesWithBindingsGetErrors,
    ThrowOnError
  >({
    url: "/2/geographies/postal-codes-with-bindings",
    ...options,
  });
};

/**
 * Delete Postal Codes Binding
 */
export const deletePostalCodesBindingGeographiesPostalCodesBindingDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeletePostalCodesBindingGeographiesPostalCodesBindingDeleteData, ThrowOnError>
) => {
  return (options.client ?? client).delete<
    DeletePostalCodesBindingGeographiesPostalCodesBindingDeleteResponses,
    DeletePostalCodesBindingGeographiesPostalCodesBindingDeleteErrors,
    ThrowOnError
  >({
    url: "/2/geographies/postal-codes-binding",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Upsert Postal Codes Binding
 */
export const upsertPostalCodesBindingGeographiesPostalCodesBindingPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpsertPostalCodesBindingGeographiesPostalCodesBindingPutData, ThrowOnError>
) => {
  return (options.client ?? client).put<
    UpsertPostalCodesBindingGeographiesPostalCodesBindingPutResponses,
    UpsertPostalCodesBindingGeographiesPostalCodesBindingPutErrors,
    ThrowOnError
  >({
    url: "/2/geographies/postal-codes-binding",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Preview Postal Codes Import
 */
export const previewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PreviewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? client).post<
    PreviewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPostResponses,
    PreviewPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportPreviewPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/2/geographies/agencies/{agency_uuid}/postal-codes-import/preview",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });
};

/**
 * Apply Postal Codes Import
 */
export const applyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    ApplyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? client).post<
    ApplyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPostResponses,
    ApplyPostalCodesImportGeographiesAgenciesAgencyUuidPostalCodesImportApplyPostErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/2/geographies/agencies/{agency_uuid}/postal-codes-import/apply",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });
};

/**
 * Get Regions
 */
export const getRegionsGeographiesRegionsGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetRegionsGeographiesRegionsGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetRegionsGeographiesRegionsGetResponses,
    GetRegionsGeographiesRegionsGetErrors,
    ThrowOnError
  >({
    url: "/2/geographies/regions",
    ...options,
  });
};

/**
 * Get Zones
 */
export const getZonesGeographiesZonesGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetZonesGeographiesZonesGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetZonesGeographiesZonesGetResponses,
    GetZonesGeographiesZonesGetErrors,
    ThrowOnError
  >({
    url: "/2/geographies/zones",
    ...options,
  });
};

/**
 * Create Zone
 */
export const createZoneGeographiesZonesPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateZoneGeographiesZonesPostData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    CreateZoneGeographiesZonesPostResponses,
    CreateZoneGeographiesZonesPostErrors,
    ThrowOnError
  >({
    url: "/2/geographies/zones",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Update Zone
 */
export const updateZoneGeographiesZonesZoneUuidPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateZoneGeographiesZonesZoneUuidPutData, ThrowOnError>
) => {
  return (options.client ?? client).put<
    UpdateZoneGeographiesZonesZoneUuidPutResponses,
    UpdateZoneGeographiesZonesZoneUuidPutErrors,
    ThrowOnError
  >({
    url: "/2/geographies/zones/{zone_uuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Agencies
 */
export const getAgenciesGeographiesAgenciesGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetAgenciesGeographiesAgenciesGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetAgenciesGeographiesAgenciesGetResponses,
    GetAgenciesGeographiesAgenciesGetErrors,
    ThrowOnError
  >({
    url: "/2/geographies/agencies",
    ...options,
  });
};

/**
 * Post Agency
 */
export const postAgencyGeographiesAgenciesPost = <ThrowOnError extends boolean = false>(
  options: Options<PostAgencyGeographiesAgenciesPostData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    PostAgencyGeographiesAgenciesPostResponses,
    PostAgencyGeographiesAgenciesPostErrors,
    ThrowOnError
  >({
    url: "/2/geographies/agencies",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete Agency
 */
export const deleteAgencyGeographiesAgenciesAgencyUuidDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteAgencyGeographiesAgenciesAgencyUuidDeleteData, ThrowOnError>
) => {
  return (options.client ?? client).delete<
    DeleteAgencyGeographiesAgenciesAgencyUuidDeleteResponses,
    DeleteAgencyGeographiesAgenciesAgencyUuidDeleteErrors,
    ThrowOnError
  >({
    url: "/2/geographies/agencies/{agency_uuid}",
    ...options,
  });
};

/**
 * Put Agency
 */
export const putAgencyGeographiesAgenciesAgencyUuidPut = <ThrowOnError extends boolean = false>(
  options: Options<PutAgencyGeographiesAgenciesAgencyUuidPutData, ThrowOnError>
) => {
  return (options.client ?? client).put<
    PutAgencyGeographiesAgenciesAgencyUuidPutResponses,
    PutAgencyGeographiesAgenciesAgencyUuidPutErrors,
    ThrowOnError
  >({
    url: "/2/geographies/agencies/{agency_uuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Urban Areas
 */
export const getUrbanAreasGeographiesUrbanAreasGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetUrbanAreasGeographiesUrbanAreasGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetUrbanAreasGeographiesUrbanAreasGetResponses,
    GetUrbanAreasGeographiesUrbanAreasGetErrors,
    ThrowOnError
  >({
    url: "/2/geographies/urban-areas",
    ...options,
  });
};

/**
 * Post Urban Area
 */
export const postUrbanAreaGeographiesUrbanAreasPost = <ThrowOnError extends boolean = false>(
  options: Options<PostUrbanAreaGeographiesUrbanAreasPostData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    PostUrbanAreaGeographiesUrbanAreasPostResponses,
    PostUrbanAreaGeographiesUrbanAreasPostErrors,
    ThrowOnError
  >({
    url: "/2/geographies/urban-areas",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete Urban Area
 */
export const deleteUrbanAreaGeographiesUrbanAreasUrbanAreaSlugDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteUrbanAreaGeographiesUrbanAreasUrbanAreaSlugDeleteData, ThrowOnError>
) => {
  return (options.client ?? client).delete<
    DeleteUrbanAreaGeographiesUrbanAreasUrbanAreaSlugDeleteResponses,
    DeleteUrbanAreaGeographiesUrbanAreasUrbanAreaSlugDeleteErrors,
    ThrowOnError
  >({
    url: "/2/geographies/urban-areas/{urban_area_slug}",
    ...options,
  });
};

/**
 * Put Urban Area
 */
export const putUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPut = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPutData, ThrowOnError>
) => {
  return (options.client ?? client).put<
    PutUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPutResponses,
    PutUrbanAreaGeographiesUrbanAreasUrbanAreaSlugPutErrors,
    ThrowOnError
  >({
    url: "/2/geographies/urban-areas/{urban_area_slug}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Departments
 */
export const getDepartmentsGeographiesDepartmentsGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetDepartmentsGeographiesDepartmentsGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetDepartmentsGeographiesDepartmentsGetResponses,
    unknown,
    ThrowOnError
  >({
    url: "/2/geographies/departments",
    ...options,
  });
};

/**
 * Get Jobs
 */
export const getJobsHohishesJobsGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetJobsHohishesJobsGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<GetJobsHohishesJobsGetResponses, unknown, ThrowOnError>({
    url: "/2/hohishes/jobs",
    ...options,
  });
};

/**
 * Get Hohishes
 */
export const getHohishesHohishesGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetHohishesHohishesGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetHohishesHohishesGetResponses,
    GetHohishesHohishesGetErrors,
    ThrowOnError
  >({
    url: "/2/hohishes",
    ...options,
  });
};

/**
 * Get Me
 */
export const getMeHohishesMeGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetMeHohishesMeGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<GetMeHohishesMeGetResponses, unknown, ThrowOnError>({
    url: "/2/hohishes/me",
    ...options,
  });
};

/**
 * Get Hohish
 */
export const getHohishHohishesHohishUuidGet = <ThrowOnError extends boolean = false>(
  options: Options<GetHohishHohishesHohishUuidGetData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    GetHohishHohishesHohishUuidGetResponses,
    GetHohishHohishesHohishUuidGetErrors,
    ThrowOnError
  >({
    url: "/2/hohishes/{hohish_uuid}",
    ...options,
  });
};

/**
 * Patch Hohish
 */
export const patchHohishHohishesHohishUuidPatch = <ThrowOnError extends boolean = false>(
  options: Options<PatchHohishHohishesHohishUuidPatchData, ThrowOnError>
) => {
  return (options.client ?? client).patch<
    PatchHohishHohishesHohishUuidPatchResponses,
    PatchHohishHohishesHohishUuidPatchErrors,
    ThrowOnError
  >({
    url: "/2/hohishes/{hohish_uuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Postings
 */
export const getPostingsHohishesHohishUuidPostingsGet = <ThrowOnError extends boolean = false>(
  options: Options<GetPostingsHohishesHohishUuidPostingsGetData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    GetPostingsHohishesHohishUuidPostingsGetResponses,
    GetPostingsHohishesHohishUuidPostingsGetErrors,
    ThrowOnError
  >({
    url: "/2/hohishes/{hohish_uuid}/postings",
    ...options,
  });
};

/**
 * Create Posting
 */
export const createPostingHohishesHohishUuidPostingsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreatePostingHohishesHohishUuidPostingsPostData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    CreatePostingHohishesHohishUuidPostingsPostResponses,
    CreatePostingHohishesHohishUuidPostingsPostErrors,
    ThrowOnError
  >({
    url: "/2/hohishes/{hohish_uuid}/postings",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete Posting
 */
export const deletePostingHohishesHohishUuidPostingsPostingUuidDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeletePostingHohishesHohishUuidPostingsPostingUuidDeleteData, ThrowOnError>
) => {
  return (options.client ?? client).delete<
    DeletePostingHohishesHohishUuidPostingsPostingUuidDeleteResponses,
    DeletePostingHohishesHohishUuidPostingsPostingUuidDeleteErrors,
    ThrowOnError
  >({
    url: "/2/hohishes/{hohish_uuid}/postings/{posting_uuid}",
    ...options,
  });
};

/**
 * Update Posting
 */
export const updatePostingHohishesHohishUuidPostingsPostingUuidPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdatePostingHohishesHohishUuidPostingsPostingUuidPostData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    UpdatePostingHohishesHohishUuidPostingsPostingUuidPostResponses,
    UpdatePostingHohishesHohishUuidPostingsPostingUuidPostErrors,
    ThrowOnError
  >({
    url: "/2/hohishes/{hohish_uuid}/postings/{posting_uuid}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Legal Entity
 */
export const getLegalEntityLegalEntitiesGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetLegalEntityLegalEntitiesGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetLegalEntityLegalEntitiesGetResponses,
    unknown,
    ThrowOnError
  >({
    url: "/2/legal-entities",
    ...options,
  });
};

/**
 * Get Security Policy
 *
 * Get the security policy mapping roles to their allowed requirements.
 *
 * Returns the complete security policy that maps role names to lists
 * of permissions they are granted.
 */
export const getSecurityPolicyPermerSecurityPolicyGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetSecurityPolicyPermerSecurityPolicyGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetSecurityPolicyPermerSecurityPolicyGetResponses,
    unknown,
    ThrowOnError
  >({
    url: "/2/permer/security-policy",
    ...options,
  });
};

/**
 * Status
 */
export const statusStatusGet = <ThrowOnError extends boolean = false>(
  options?: Options<StatusStatusGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<StatusStatusGetResponses, unknown, ThrowOnError>({
    url: "/2/status",
    ...options,
  });
};

/**
 * Status Db
 */
export const statusDbStatusDbGet = <ThrowOnError extends boolean = false>(
  options?: Options<StatusDbStatusDbGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<StatusDbStatusDbGetResponses, unknown, ThrowOnError>({
    url: "/2/status-db",
    ...options,
  });
};

/**
 * Boom
 */
export const boomBoomGet = <ThrowOnError extends boolean = false>(
  options?: Options<BoomBoomGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<BoomBoomGetResponses, unknown, ThrowOnError>({
    url: "/2/boom",
    ...options,
  });
};
